import snakecaseKeys from 'snakecase-keys';

const serializeOne = (v: object) => (snakecaseKeys(
  v,
  { deep: true },
));

export {
  /* eslint-disable-next-line import/prefer-default-export */
  serializeOne,
};
